export { default as Gtm } from './Gtm.js';
export { default as Lang } from './Lang.js';
export { default as LazySizes } from './LazySizes.js';
export { default as WindowEvents } from './WindowEvents.js';
export { default as ScrollbarWidth } from './ScrollbarWidth.js';
export { default as LockScroll } from './LockScroll.js';
export { default as UI } from './UI.js';
export { default as Tabs } from './Tabs.js';
export { default as TabFocus } from './TabFocus.js';
export { default as Slider } from './Slider.js';
export { default as SliderKeyboard } from './SliderKeyboard.js';
export { default as PagePersonal } from './PagePersonal.js';
export { default as pagePersonalDataForm } from './PagePersonalDataForm.js';
export { default as CommonPopup } from './CommonPopup.js';
export { default as PageAuth } from './PageAuth.js';
export { default as HintProduct } from './HintProduct.js';  // используется в подвале
export { default as Plyr } from './Plyr.js';
export { default as Anchors } from './Anchors.js';
export { default as StickyBlock } from './StickyBlock.js';
export { default as PwaController } from './PwaController.js';
export { default as cookieDisclaimer } from './CookieDisclaimer.js';
export { default as OptionsLinks } from './OptionsLinks';
export { default as QuickRegistration } from './QuickRegistration';
export { default as PageWhatWeDo } from './PageWhatWeDo';
export { default as DropdownModal } from './DropdownModal.js';
export { default as Footer } from './Footer.js';

// constructor
export { default as ConstructorColors } from '../constructor/c-colors.js';

export { default as Preloader } from './Preloader.js'; // Должен быть последним
//export { default as PixePerfectProxy } from './PixePerfectProxy.js';


//if(document.querySelector('.page-constructor')) {
    // только конструктор
    import('../constructor/_constructor.js');
    document.querySelector('.js-product-block-slider') && import('../constructor/c-product.js');
    document.querySelector('.js-poll-block, .js-poll-several-items-form, .js-poll-columns-form') && import('../constructor/c-poll.js');
    document.querySelector('.js-poll-product') && import('../constructor/c-product-poll.js');
    document.querySelector('.js-scroll-video, .js-scroll-animation, .js-scroll-animation-all-devices') && import('../constructor/c-scroll-animation.js');
    document.querySelector('.js-common-popup[data-name="confirmation"]') && import('../constructor/c-popup-confirmation.js');
    document.querySelector('.js-proccess-animation') && import('../constructor/c-vitaprost-animation.js'); // TODO возможно вынести в vitaprost
    document.querySelector('.js-cystitis') && import('../constructor/c-fenazalgin.js'); // TODO возможно вынести в fenazalgin
    document.querySelector('.js-fly-boxes-slider') && import('../constructor/c-fly-boxes-slider.js');
    document.querySelector('.js-poll-webinar-form') && import('../constructor/c-poll-webinar.js');
    document.querySelector('.js-webinar-item') && import('../constructor/c-webinars.js');
    document.querySelector('.js-calories-product-category') && import('../constructor/c-callories-calculator.js');
    document.querySelector('.js-coldrex-filter') && import('../constructor/c-coldrex.js'); // TODO возможно вынести в coldrex
    document.querySelector('.js-cookbook-modal') && import('./AccordeonCookBook.js');
    document.querySelector('.js-departments-map-wrap') && import('./PopupDepartmentsMap.js');
    document.querySelector('.js-page-pattern') && import('./PatternsOnPage.js'); // TODO возможно вынести в vitaprost
    document.querySelector('[data-pixel-aid]') && import('./Pixel');
    document.querySelector('[data-products-line-slider]') && import('./SliderLineProducts');
//} else {
    // только штада
    import('./_main.js');
    document.querySelector('.js-view-pdf') && import('./ViewPdf.js');
    document.querySelector('.js-products-filter-form, .js-catalog-with-pages') && import('./PageProducts.js');
    document.querySelector('.page-products-store, .page-for-specialists-auth, .js-product-offers, .js-product-card, .js-order-form, .js-store-product') && import('../store/_store.js') && import('../modules/Form.js');
    document.querySelector('.page-supervision, .page-intern-form') && import('./PageSupervision.js') && import('./PageInternForm.js');
    document.querySelector('.js-sidebar-nav-select') && import('./SidebarNav.js');
    document.querySelector('.page-faq') && import('./PageFaq.js');
    document.querySelector('.page-for-specialists, .js-mask-phone, .js-personal-data-form') && import('./Mask.js');
    document.querySelector('.page-health-questions') && import('./PageHealth.js');
    document.querySelector('.js-grid') && import('./MuuriGrid.js');
    document.querySelector('.js-popup-img-link') && import('./PageHealthReport.js');
    document.querySelector('.js-favorites-btn') && import('./Favorites.js');
    document.querySelector('.js-calculator,.js-calculator-score,.js-medicines') && import('./Calculator.js');
    document.querySelector('.js-events-more-container') && import('./PageEvents.js');
    document.querySelector('.animation-element') && import('./AnimationElement.js');
    document.querySelector('.js-graphics') && import('./Graphics.js');
    document.querySelector('.broadcast-block') && import('./Broadcast.js');
    document.querySelector('.js-product-review') && import('./PopupReview.js'); // TODO по хорошему перенести в store
    document.querySelector('.thumb-slider-wrap-ginekology') && import('./videoRegistrationInformer.js');
    document.querySelector('.js-disclosure-wrap') && import('./PageDisclosure.js');
    document.querySelector('.video-block, .text video') && import('./VideoUrlControl.js');
    document.querySelector('.page-products') && import('./JsLink.js');
    document.querySelector('.js-common-popup[data-name="med-confirmation"]') && import('./popupMedConfirmation.js');
    document.querySelector('html[data-circles]') && import('./ColorCircles.js');
    document.querySelector('.js-anchor-nav-select') && import('./AnchorNav.js');
    document.querySelector('.page-store-search') && import('./PageSearch.js');
    document.querySelector('.page-vacancies') && import('./PageVacancies.js');
    document.querySelector('.js-vebinar-wrap, .js-events-calendar') && import('./PageSpecialists.js');
//}

// и штада и конструктор
document.querySelector('.js-more-container') && import('./LoadMore.js');
Array.from(document.querySelectorAll('.js-form')).some(formDom => !formDom.closest('.js-common-popup')) && import('./Form.js');
document.querySelector('.table, .js-title-header, .js-select-links, .webinar, .js-speciality-show') && import('./PageStyles.js');
document.querySelector('.js-video-item-wrap') && import('./YoutubeVideo.js');
document.querySelector('.content-list-view-autoclose') && import('./CollapseList.js');
document.querySelector('.page-tests,.js-tests-wrapper') && import('./PageTests.js');
document.querySelector('.accordeon-item, .js-toggle-item') && import('./Accordeon.js');
document.querySelector('.js-thumb-slider') && import('./ThumbSlider.js');
document.querySelector('.js-video-frame-wrap') && import('./BannerVideo.js');
document.querySelector('.js-other-news-slider, .js-slider-articles-3, .js-slider-articles-auto') && import('./SliderOtherNews.js');
document.querySelector('.js-flip-icon') && import('./FlipCards.js');
document.querySelector('.page-product') && import('./ProductItem.js');
document.querySelector('.js-timeline') && import('./Timeline.js');
document.querySelector('.js-dadata-surname,.js-dadata-name,.js-dadata-patronymic,.js-dadata-last-name,.js-dadata-fio,.js-dadata-country,[data-dadata-country],.js-dadata-city') && import('./Dadata.js');
document.querySelector('.js-poll-wrap-form') && import('./Polls.js');
document.querySelector('.js-scroll-top-button') && import('./ScrollTop.js');
document.querySelector('.js-digits-item-counter, [data-digits-val]') && import('./Digits.js');
document.querySelector('.js-anchor-menu') && import('./AnchorMenu.js');
App.ie && import('./SVG-symbols-ie.js');
/bgColor/.test(document.location.search) && import('./formFrames.js');
document.querySelector('.js-popup-gallery-item,.js-store-product') && import('./Popup.js');
document.querySelector('.page-contacts') && import('./PageContacts.js');
document.querySelector('.js-simple-tab') && import('../store/SimpleTabs.js');
document.querySelector('.calc_top_block') && import('./OvulationCalculator.js');
